export const CATEGORIES = {
    APPRENDRE: 155,
    EMISSIONS: 170,
    PLANIFIER: 152,
    RECETTES: 0,
};
